import React from "react";
import { getHistoryIconFromType } from "./utils";
import { Container, Header, History, Item, Date, Description, Text, Icon, Updated } from "./styled/listing-history";
function ListingHistory(_a) {
    var history = _a.history, updatedAtDateShort = _a.updatedAtDateShort, updatedAtTime = _a.updatedAtTime;
    return (React.createElement(Container, null,
        React.createElement(Header, null, "History"),
        React.createElement(History, null, history.map(function (_a, index) {
            var date = _a.date, type = _a.type, description = _a.description;
            var IconType = getHistoryIconFromType(type || "");
            return (React.createElement(Item, { key: index },
                React.createElement(Date, null, date),
                React.createElement(Description, null,
                    React.createElement(Text, null,
                        React.createElement(Icon, { type: type || "" },
                            React.createElement(IconType, null)),
                        description))));
        })),
        updatedAtDateShort && (React.createElement(Updated, null, "Last Updated " + updatedAtDateShort + " at " + updatedAtTime))));
}
export default ListingHistory;
